import React from "react"
import { getMaterial900ColorFrom500Color } from "../../../../helpers/utils"
import { IPosition, IScheduleShift } from "../../../../models"
import { getEventTimeRange } from "../../../../helpers/scheduleHelper"
import AccountStore from "../../../../stores/AccountStore"
import "./styles.css"
import { green800 } from "material-ui/styles/colors"
export interface IShiftEvent {
	readonly?: boolean
	start: Date
	end: Date
	id?: string
	name?: string
	shift?: IScheduleShift
	holidayName?: string
	onRightClick?(shift: IScheduleShift, e: React.MouseEvent<HTMLElement>): void
}
export interface IEventProps {
	event: IShiftEvent
}

export const MonthEvent: React.SFC<IEventProps> = (props: IEventProps) => {
	if (props.event.shift) {
		const handleClick = (e: React.MouseEvent<HTMLElement>) => {
			if (e.nativeEvent.button === 2) {
				e.preventDefault()
				!props.event.readonly && props.event.onRightClick(props.event.shift, e)
			}
		}
		const position: IPosition = AccountStore.getCurrentAccount().PositionDefinitions.find(item => item.Id === props.event.shift.PositionId)
		const positionColor = position && position.Color ? position.Color : AccountStore.getPositionDefaultColor()
		return (
			<div
				className="Calendar-Event"
				style={{ background: positionColor }}
				onClick={handleClick}
				onContextMenu={handleClick}
			>
				<span className={"Calendar-EventTime"}>{getEventTimeRange(props.event)}</span>
				<span className={"Calendar-EventTitle"} style={{ background: getMaterial900ColorFrom500Color(positionColor), color: "rgba(254, 254, 254, 0.5)" }}>
					{props.event.shift.Name}
				</span>
			</div>
		)
	}
	else {
		return (
			<div
				className="Calendar-Event"
				style={{ background: green800, display: "flex", alignItems: "center", justifyContent: "center" }}
			>
				{props.event.holidayName}
			</div>
		)
	}
}
